/**
 * Encore Foundation - 10.25.0
 *
 * The contents of this file is owned and generated by the Encore team.
 * If you need to make changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Encore
 * encore.spotify.net
 */

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Medium instead
 */
export const desktopBallad = {
  fontSize: '1rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Medium Bold instead
 */
export const desktopBalladBold = {
  fontSize: '1rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Small instead
 */
export const desktopViola = {
  fontSize: '0.875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Small Bold instead
 */
export const desktopViolaBold = {
  fontSize: '0.875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Small instead
 */
export const desktopMesto = {
  fontSize: '0.875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Small Bold instead
 */
export const desktopMestoBold = {
  fontSize: '0.875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Headline Large instead
 */
export const desktopBass = {
  fontSize: '6rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 800,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Headline Medium instead
 */
export const desktopForte = {
  fontSize: '4.5rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 800,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Large instead
 */
export const desktopBrio = {
  fontSize: '3rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated In order to better support non-latin languages, the all-caps type styles have been deprecated. You can learn more about the reasons and replacements on http://go/all-caps-deprecation
 */
export const desktopMetronome = {
  fontSize: '0.875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated In order to better support non-latin languages, the all-caps type styles have been deprecated. You can learn more about the reasons and replacements on http://go/all-caps-deprecation
 */
export const desktopMinuet = {
  fontSize: '0.75rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated In order to better support non-latin languages, the all-caps type styles have been deprecated. You can learn more about the reasons and replacements on http://go/all-caps-deprecation
 */
export const desktopMinuetBold = {
  fontSize: '0.75rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Marginal instead
 */
export const desktopFinale = {
  fontSize: '0.6875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Marginal Bold instead
 */
export const desktopFinaleBold = {
  fontSize: '0.6875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Large instead
 */
export const desktopAltoBrio = {
  fontSize: '3rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Medium instead
 */
export const desktopAlto = {
  fontSize: '2rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Small instead
 */
export const desktopCanon = {
  fontSize: '1.5rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Small instead
 */
export const desktopCelloCanon = {
  fontSize: '1.5rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Medium Bold instead
 */
export const desktopCello = {
  fontSize: '1.125rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};
